import React, { FC } from 'react';
import { DynamicComponent, Errors, HeaderText } from '@/components';
import { TypeAccountPage } from '@/core/generated-types';
import { HeaderSize } from '@/components/ui/HeaderText';
import { findApplicableErrorDetails } from '@/components/common/Errors/utils';

export type MyCoursePacksPageLayoutProps = {
  page: TypeAccountPage;
  error?: string | undefined;
};

const MyCoursePacksPageLayout: FC<MyCoursePacksPageLayoutProps> = ({
  page,
  error,
}) => {
  const {
    fields: { title, components, errorDirectives },
  } = page;

  const { heading, errors } = findApplicableErrorDetails(errorDirectives);
  const errorsWithServerErrorMessage = error ? errors.concat([error]) : errors;

  return (
    <div className="overflow-hidden">
      <HeaderText
        text={title}
        align="center"
        size={HeaderSize.H1}
        classes="mt-6 lg:mt-10 container mx-auto"
      />
      {error ? (
        <Errors
          heading={heading}
          errors={errorsWithServerErrorMessage}
          classes="mt-10 mx-auto container"
        />
      ) : (
        <section>
          {components &&
            components.map((component) => (
              <DynamicComponent key={component.sys.id} component={component} />
            ))}
        </section>
      )}
    </div>
  );
};

export default React.memo(MyCoursePacksPageLayout);
